export const createFieldId = (field: string) => {
  return `${field}_${generateRandomString()}`;
};

export const generateRandomString = () => {
  return "xxxxxxxx".replace(/[x]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const keepOnlyLettersAndNumbers = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]/g, "");
};
